// convenience className function

import { devWarn } from "@/util/dev.mjs";

export type ClassNameEntry =
  | string
  | boolean
  | (() => string)
  | null
  | number
  | undefined;

// filters nullish and falsy values so you don't have to return "" for falsey
export function classNames(...args: ClassNameEntry[]): {
  className?: string;
} {
  const classNames = args.reduce(resolveClassNames, [] as string[]);

  if (classNames.length === 0) {
    return {};
  }

  return {
    className: classNames.join(" "),
  };
}

function resolveClassNames(acc: string[], entry: ClassNameEntry): string[] {
  if (typeof entry === "function") {
    acc.push(entry());
  } else if (typeof entry === "string") {
    acc.push(entry);
  } else if (entry === true) {
    devWarn("classNames: true is not a valid class name");
  }

  return acc;
}
